import React, { useRef, useState, useEffect } from 'react';

const Container = (WrappedComponent, offsetTop) => {
  const handles = [];
  const printHandler = [];
  let ticking = false;
  const throttleScroll = () => {
    ticking =
      ticking ||
      requestAnimationFrame(() => {
        ticking = false;
        handles.map((handle) => handle());
      });
  };

  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', throttleScroll, false);

    window.addEventListener('resize', throttleScroll, false);

    const mediaQueryList = window.matchMedia('print');
    mediaQueryList.addListener((mql) => {
      if (mql.matches) {
        printHandler.map((handle) => handle());
      }
    });
  }
  return (props) => {
    const viewport = useRef();
    const [isInViewPort, setIsInViewPort] = useState(false);
    const [isViewed, setIsViewed] = useState(false);
    const [isBrowserTop, setIsBrowserTop] = useState(false);
    const [isBottomBrowserTop, setIsBottomBrowserTop] = useState(null);
    const [isInRange, setIsInRange] = useState(false);

    const getBoundingClientRect = () => {
      return viewport.current.getBoundingClientRect();
    };

    const isComponentInViewPort = () => {
      requestAnimationFrame(() => {
        if (!viewport.current) return;

        const rect = getBoundingClientRect();
        const offset = offsetTop ? offsetTop : 0;

        if (rect.top - (window.innerHeight + offset) <= 0) {
          if (!isInViewPort) {
            setIsInViewPort(true);
            setIsViewed(true);
          }
        } else {
          isInViewPort && setIsInViewPort(false);
        }
      });
    };

    const isComponentBrowserTop = () => {
      if (!viewport.current) return;

      const rect = getBoundingClientRect();
      if (rect.top < 1) {
        !isBrowserTop && setIsBrowserTop(true);
      } else {
        isBrowserTop && setIsBrowserTop(false);
      }
    };

    const isComponentBottomBrowserTop = () => {
      if (!viewport.current) return;

      const rect = getBoundingClientRect();
      if (rect.bottom > 0) {
        isBottomBrowserTop === false && setIsBottomBrowserTop(true);
      } else {
        isBottomBrowserTop !== false && setIsBottomBrowserTop(false);
      }
    };

    const isComponentWithinRange = () => {
      if (!viewport.current) return;

      const rect = getBoundingClientRect();
      if (rect.top < 1 && rect.bottom > 0) {
        !isInRange && setIsInRange(true);
      } else {
        isInRange && setIsInRange(false);
      }
    };

    const isPrinting = () => {
      setIsInViewPort(true);
      setIsViewed(true);
    };

    useEffect(() => {
      isComponentInViewPort();
      setTimeout(() => {
        isComponentInViewPort();
      }, 200);

      handles.push(isComponentInViewPort);
      handles.push(isComponentBrowserTop);
      handles.push(isComponentBottomBrowserTop);
      handles.push(isComponentWithinRange);
      printHandler.push(isPrinting);
    }, [isInRange]);

    return (
      <div ref={viewport}>
        <WrappedComponent
          {...props}
          isInViewPort={isInViewPort}
          isViewed={isViewed}
          isBrowserTop={isBrowserTop}
          isBottomBrowserTop={isBottomBrowserTop}
          isInRange={isInRange}
        />
      </div>
    );
  };
};

export default Container;
